/**
 * @flow
 * @relayHash 72282dab39a378fcdbd69d35fbc266e5
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteCustomerCategoryMutationVariables = {|
  id: string
|};
export type DeleteCustomerCategoryMutationResponse = {|
  +deleteCustomerCategory: {|
    +id: string
  |}
|};
export type DeleteCustomerCategoryMutation = {|
  variables: DeleteCustomerCategoryMutationVariables,
  response: DeleteCustomerCategoryMutationResponse,
|};
*/


/*
mutation DeleteCustomerCategoryMutation(
  $id: String!
) {
  deleteCustomerCategory(id: $id) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteCustomerCategory",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "CustomerCategoryModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteCustomerCategoryMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteCustomerCategoryMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteCustomerCategoryMutation",
    "id": null,
    "text": "mutation DeleteCustomerCategoryMutation(\n  $id: String!\n) {\n  deleteCustomerCategory(id: $id) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '55ec8cad5b037dafa66485ce3b1059a5';
module.exports = node;
